import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import type { Article } from "@/mocks/types";

function ArticleCard({ article }: { article: Article }) {
  return (
    <Link
      to={`/article/${article.id}`}
      className="group flex flex-col sm:flex-row gap-4 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-300/60 p-4 transition-all duration-300"
    >
      <div className="relative w-full sm:w-48 h-32 flex-shrink-0 rounded-lg overflow-hidden">
        <img
          src={article.thumbnail}
          alt={article.title}
          title={article.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-1.5">
          <span className="text-xs bg-secondary-100/70 text-secondary-600 px-2 py-0.5 rounded-full">
            {article.category === "movie" ? "电影" : article.category === "tv" ? "电视剧" : article.category === "anime" ? "动漫" : article.category === "documentary" ? "纪录片" : article.category === "sports" ? "体育" : article.category === "game" ? "游戏" : "综艺"}
          </span>
          <span className="text-xs text-foreground-400">{article.publishDate}</span>
        </div>
        <h3 className="text-sm font-semibold text-foreground-950 line-clamp-1 mb-1.5 group-hover:text-primary-500 transition-colors">
          {article.title}
        </h3>
        <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed mb-2">
          {article.excerpt}
        </p>
        <div className="flex items-center gap-3 text-xs text-foreground-400">
          <span>{article.author}</span>
          <span>{(article.views / 10000).toFixed(1)}万阅读</span>
        </div>
      </div>
    </Link>
  );
}

export default function LatestArticles() {
  const latest = articles.slice(0, 4);

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
              最新资讯
            </h2>
            <p className="text-sm text-foreground-500 mt-2">影视资讯、深度评论，精彩不容错过</p>
          </div>
        </div>

        <div className="flex flex-col gap-4">
          {latest.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>

        <div className="text-center mt-8 sm:hidden">
          <Link
            to="/category/movie"
            className="inline-flex items-center gap-1.5 text-sm text-primary-500 font-medium"
          >
            查看更多
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}